<template>
  <div class="brand-page" ref="gallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>用户详情
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto;" class="filtrate">
      <div style="width: 1056px;margin: 0 auto;border:1px solid #ddd; display:flex;">
        <div class="head_left">
          <div class="head_left_div">
            <div style="width:72px;height:72px">
              <img
                style="width:72px;height:72px"
                :src="serve+'' +  json.logo"
                alt
              />
            </div>
            <p>logo</p>
          </div>
        </div>
        <div class="head_center">
          <div class="table1">
            <table class="tab_box" cellspacing="0">
              <tr class="tab_tr">
                <th class="tab_th">用户账号</th>
                <td class="tab_td">{{json.username}}</td>
              </tr>

              <tr class="tab_tr">
                <th class="tab_th">修改时间</th>
                <td class="tab_td">{{json.update_date}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">销量</th>
                <td class="tab_td">{{json.sell}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">可上传商品</th>
                <td class="tab_td">{{json.product_number}}</td>
              </tr>

              <tr class="tab_tr">
                <th class="tab_th">过期时间</th>
                <td class="tab_td">{{json.token_time}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">排序</th>
                <td class="tab_td">
                  <div style="display:flex;justify-content: space-between;align-items:center">
                    <span>{{json.order_by}}</span>
                    <span style="padding-right:20px;color:#3498db;cursor: pointer;">
                      <el-button @click="dialogVisible = true" size="mini">排序</el-button>
                    </span>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="head_right">
          <div class="table1">
            <table class="tab_box" cellspacing="0">
              <tr class="tab_tr">
                <th class="tab_th">主要产品</th>
                <td class="tab_td">{{json.main_product}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">联系电话</th>
                <td class="tab_td">{{json.link_phone}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">联系人</th>
                <td class="tab_td">{{json.link_member}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">邮箱</th>
                <td class="tab_td">{{json.email}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">公司名称</th>
                <td class="tab_td">{{json.company}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">地址</th>
                <td class="tab_td">{{json.address}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div style="width: 1056px;margin: 0 auto;border:1px solid #ddd;margin-top:20px;">
        <div class="table1">
          <template>
            <div
              style="display:flex;align-items:center;justify-content: space-between;padding-top:20px;"
            >
              <div style="display:flex;align-items:center;  ">
                <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
                <p style="margin-left:6px;color:#333">banner图</p>
              </div>
              <div style="margin-right:10px">
                <el-button size="small" @click="dialogVisible1 = true">修改密码</el-button>
              </div>
            </div>
            <div
              style="height:100px;width:90%;margin: 0 auto;border: 1px solid rgba(221, 221, 221, 1);"
            >
              <img
                style="height:100px;width:100%"
                :src="serve+'' + json.banner"
                alt
              />
            </div>
          </template>
        </div>
        <div class="table1">
          <template>
            <div style="display:flex;align-items:center; justify-content: space-between;">
              <div style="display:flex;align-items:center; ">
                <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
                <p style="margin-left:6px;color:#333">商品信息</p>
              </div>

              <div class="show_total">
                <el-dropdown trigger="click" @command="change_page_num1">
                  <span class="el-dropdown-link show_total_span" style="c">
                    显示条数
                    <i style="font-size: 12px;" class="iconfont icon-sanjiaoxing"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="5">每页5条</el-dropdown-item>
                    <el-dropdown-item :command="10">每页10条</el-dropdown-item>
                    <el-dropdown-item :command="15">每页15条</el-dropdown-item>
                    <el-dropdown-item :command="20">每页20条</el-dropdown-item>
                    <el-dropdown-item :command="50">每页50条</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>

            <el-table
              style="width: 96%;margin:0 auto"
              row-key="id"
              :data="tabData1"
              v-loading="loading"
              border
              ref="multipleTable"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
              @selection-change="handleSelectionChange"
            >
              <el-table-column align="center" type="selection" width="55"></el-table-column>
              <el-table-column prop="title" align="center" label="名称" show-overflow-tooltip></el-table-column>

              <el-table-column prop="item_no" align="center" label="货号"></el-table-column>

              <el-table-column prop="brand" align="center" label="品牌"></el-table-column>

              <el-table-column show-overflow-tooltip prop="specification" align="center" label="规格"></el-table-column>

              <el-table-column show-overflow-tooltip prop="top_class" align="center" label="分类"></el-table-column>
              <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                  <span>
                    <el-button
                      @click="change_audit(scope.row.id)"
                      :disabled="scope.row.check =='1'"
                      size="mini"
                    >{{scope.row.check == '0' ? '未审核' : '已通过'}}</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div style="display:flex;justify-content:space-between;align-items: center;">
            <div style="margin:0 0 0 20px ;">
              <el-button @click="toggleSelection(tabData1)" size="mini">全选</el-button>
              <el-button @click="change_check" size="mini">选中上传</el-button>
            </div>
            <div class="pager" style="text-align:right ; margin:0;">
              <el-row>
                <el-col>
                  <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :total="total1"
                    :page-size="limit"
                    @current-change="setPage1"
                    hide-on-single-page
                  ></el-pagination>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="table1 table_bottom">
          <template>
            <div style="display:flex;align-items:center; justify-content: space-between;">
              <div style="display:flex;align-items:center; ">
                <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
                <p style="margin-left:6px;color:#333">订单详情</p>
              </div>

              <div class="show_total">
                <el-dropdown trigger="click" @command="change_page_num2">
                  <span class="el-dropdown-link show_total_span" style="c">
                    显示条数
                    <i style="font-size: 12px;" class="iconfont icon-sanjiaoxing"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="5">每页5条</el-dropdown-item>
                    <el-dropdown-item :command="10">每页10条</el-dropdown-item>
                    <el-dropdown-item :command="15">每页15条</el-dropdown-item>
                    <el-dropdown-item :command="20">每页20条</el-dropdown-item>
                    <el-dropdown-item :command="50">每页50条</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>

            <el-table
              v-loading="loading1"
              border
              :data="order_tabData"
              style="width: 96%; margin:0 auto"
              header-row-class-name="row-header"
            >
              <el-table-column prop="link_name" align="center" label="姓名"></el-table-column>
              <el-table-column prop="bind_mobile" align="center" width="120" label="电话"></el-table-column>
              <el-table-column prop="orderCode" align="center" label="订单编号" width="200"></el-table-column>
              <el-table-column prop="pay_money" align="center" label="订单金额"></el-table-column>

              <el-table-column align="center" label="支付方式">
                <template slot-scope="scope">{{scope.row.pay_type == '1' ? '在线支付' : '账期支付'}}</template>
              </el-table-column>
              <el-table-column prop="create_time" align="center" label="下单时间" width="180"></el-table-column>
              <el-table-column align="center" label="订单状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == '0'">待付款</span>
                  <span v-if="scope.row.status == '1'">待采购</span>
                  <span v-if="scope.row.status == '2'">待发货</span>
                  <span v-if="scope.row.status == '3'">待收货</span>
                  <span v-if="scope.row.status == '4'">待评价</span>
                  <span v-if="scope.row.status == '5'">已完成</span>
                  <span v-if="scope.row.status == '6'">已取消</span>
                </template>
              </el-table-column>
              <el-table-column prop="express.express_code" align="center" label="操作">
                <template slot-scope="scope">
                  <button class="button1" @click="inser(scope.row.id)">查看订单</button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div class="pager" style="text-align:right ; margin:0;">
            <el-row>
              <el-col>
                <el-pagination
                  background
                  layout="total,prev, pager, next"
                  :total="order_total"
                  :page-size="order_limt"
                  @current-change="setPage2"
                  hide-on-single-page
                ></el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="排序" :visible.sync="dialogVisible" width="30%">
      <span>
        <el-input v-model="order_by" placeholder="请输入排序号" style="width:360px"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="order_submit()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="dialogVisible1" width="30%">
      <span>
        <el-input v-model="password" placeholder="请输入密码" style="width:360px"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="change_pass()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
   

<script>
export default {
  name: "gallery",
  data() {
    return { serve: this.$store.state.serve,
      serve: this.$store.state.serve,
      id: this.$route.params.id,
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      json: {},
      dialogVisible: false,
      dialogVisible1: false,
      order_by: "",
      password: "",
      tabData1: [],
      loading: false,
      total1: null,
      page1: null,
      limit: 5,
      order_page: null,
      order_total: null,
      order_tabData: [],
      loading1: false,
      order_limt: 5,
      list_id: []
    };
  },
  created() {
    this.$store.state.topActiveId = 10;
    this.$store.state.leftTitle = "商户列表";
    this.geting();
    this.audit();
    this.order_list();
  },
  watch: {},

  methods: {
     inser(id){
         this.$router.push('/admin/shoplookorder/' + id)
     },
    change_check() {
      var string_id = JSON.stringify(this.list_id);
      this.axios
        .get(this.serve + "/admin/checkProduct", {
          params: {
            username: this.username,
            token: this.token,
            id: string_id
          }
        })
        .then(res => {

          this.audit(this.page1);
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    change_page_num2(limit) {
      this.order_limt = limit;
      this.order_list();
    },
    setPage2(page) {
      this.order_list(page);
    },
    order_list(page) {
      this.loading1 = true;
      this.axios
        .get(this.serve + "/admin/orderList", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            page,
            limit: this.order_limt
          }
        })
        .then(res => {
          this.loading1 = false;
          this.order_tabData = [];
          if (res.data.status == "success") {
            this.order_page = res.data.data.page;
            this.order_total = res.data.data.total;
            this.order_tabData = res.data.data.results;
          }
        });
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.toggleAllSelection();
    },
    handleSelectionChange(val) {
      var list_id = [];
      for (var i in val) {
        list_id.push(val[i].id);
      }
      this.list_id = list_id;
    },
    change_page_num1(limit) {
      this.limit = limit;
      this.audit();
    },
    setPage1(page) {
      this.audit(page);
    },

    change_audit(id) {
      const pid = JSON.stringify(id.split(","));
      this.$confirm("此操作将审核改商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/checkProduct", {
              params: {
                username: this.username,
                token: this.token,
                id: pid
              }
            })
            .then(res => {
              this.audit(this.page1);
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
              } else if (res.data.status == "error") {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消审核"
          });
        });
    },
    audit(page) {
      this.loading = true;
      this.axios
        .get(this.serve + "/admin/shopProductList", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            page,
            limit: this.limit
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.status == "success") {
            this.tabData1 = res.data.data.results;
            this.total1 = res.data.data.total;
            this.page1 = res.data.data.page;
          }
        });
    },
    change_pass() {
      this.axios
        .get(this.serve + "/admin/changePass", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            pass: this.password
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    order_submit() {
      this.axios
        .get(this.serve + "/admin/shopEditSort", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            sort: this.order_by
          }
        })
        .then(res => {
          this.dialogVisible = false;
          this.geting();
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    geting(id) {
      this.axios
        .get(this.serve + "/admin/shopInfo", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.json = res.data.data;
          }
        });
    }
  }
};
</script>

<style lang="scss">
.el-table th {
  background-color: rgba(245, 250, 249, 1);
}
.topBar {
  margin-bottom: 40px;

  .el-step__icon {
    height: 54px;
    width: 54px;
  }
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .rutun:hover {
    color: #0099ff;
  }
}
.table_bottom {
  padding-bottom: 30px;
}
.table1 {
  background: #fff;
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .tab_box {
    width: 412px;
    margin: 0 auto;
    .tab_tr {
      border: 1px solid rgba(221, 221, 221, 1);
      .tab_th {
        padding: 0;
        margin: 0;
        width: 100px;
        height: 44px;
        background: rgba(245, 250, 249, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 14px;
        text-align: right;
        padding-right: 40px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .tab_td {
        padding: 0;
        margin: 0;
        border: 1px solid rgba(221, 221, 221, 1);
        padding-left: 20px;
        font-size: 14px;
        width: 312px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}

.filtrate {
  width: 1060px;
  margin-left: 420px;
  // background: orange;
  .head_left {
    width: 240px;
    //  height: 230px;
    background: #f5faf9;
    .head_left_div {
      width: 100%;
      height: 100%;
      color: #cccccc;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        font-style: normal;
      }
    }
  }
  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    // background: pink;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .form-title {
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
}
.brand-page {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .show_total {
    font-size: 12px;
    width: 100px;
    height: 30px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    cursor: pointer;
    line-height: 30px;
    margin-right: 10px;
  }
  .show_total:hover {
    color: #3498db;
  }
  .show_total_span:hover {
    color: #3498db;
  }
  .claify {
    width: 4px;
    height: 16px;
    background: rgba(52, 152, 219, 1);
    position: absolute;
    top: 17px;
    left: -10px;
  }
  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    position: relative;
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
}
</style>

